"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxInput = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const utils_1 = require("@obvio/utils");
const react_1 = require("react");
const utils_2 = require("./utils");
const StyledCheckboxGroup = app_1.styled.label `
  display: flex;
  align-items: center;
  cursor: pointer;

  ${(theme) => { var _a; return (_a = theme.inputs.checkbox) === null || _a === void 0 ? void 0 : _a.wrapper; }};

  &.focus-visible:not(.with-value) {
    > input {
      &:after {
        display: none;
      }
      /* background: ${(theme) => theme.colors.primary.alpha(0.3)}; */
    }
  }
`;
const StyledLabel = app_1.styled.span((theme) => {
    var _a;
    return [
        theme.inputs.label,
        (0, app_1.css) `
    position: static;
    ${app_1.styled.invalid `
      color: ${theme.colors.error};
    `}
  `,
        (_a = theme.inputs.checkbox) === null || _a === void 0 ? void 0 : _a.label,
    ];
});
function CheckboxInputElem(_a) {
    var { value, label, hasError, onChange, onBlur, className, optional, success, prefix, suffix } = _a, props = __rest(_a, ["value", "label", "hasError", "onChange", "onBlur", "className", "optional", "success", "prefix", "suffix"]);
    const id = (0, app_1.useCuid)();
    const [focus, setFocus] = (0, react_1.useState)(false);
    const focusVisible = (0, utils_1.cls)({
        'focus-visible': focus,
        'with-value': Boolean(value),
    });
    const disabled = Boolean(props.disabled);
    return ((0, jsx_runtime_1.jsxs)(StyledCheckboxGroup, Object.assign({ htmlFor: id, className: (0, utils_1.cls)(className, focusVisible) }, (0, utils_2.aria)({ invalid: hasError, checked: value, disabled }), { children: [(0, jsx_runtime_1.jsx)(utils_2.Checkbox, Object.assign({}, props, { onFocus: () => setFocus(true), onBlur: () => setFocus(false), onChange: (ev) => {
                    const { checked } = ev.target;
                    onChange === null || onChange === void 0 ? void 0 : onChange(checked);
                    onBlur === null || onBlur === void 0 ? void 0 : onBlur(checked);
                }, className: focusVisible, id: id, checked: value, onKeyDown: (ev) => {
                    var _a;
                    if (ev.key === 'Tab') {
                        return;
                    }
                    ev.preventDefault();
                    return (/^(Enter| |Space)$/u.test(ev.key) &&
                        ((_a = ev.currentTarget.parentElement) === null || _a === void 0 ? void 0 : _a.click()));
                } }, (0, utils_2.aria)({ invalid: hasError, checked: value, disabled }))), (0, jsx_runtime_1.jsx)(StyledLabel, Object.assign({}, (0, utils_2.aria)({ invalid: hasError, checked: value, disabled }), { children: label }))] })));
}
function CheckboxInput(_a) {
    var { defaultValue = false, optional = true } = _a, props = __rest(_a, ["defaultValue", "optional"]);
    return ((0, jsx_runtime_1.jsx)(utils_2.InputController, Object.assign({}, props, { render: CheckboxInputElem, defaultValue: defaultValue, optional: optional })));
}
exports.CheckboxInput = CheckboxInput;
